import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import Amazo from "../../Assets/Projects/Amazo.PNG";
import Resturant from "../../Assets/Projects/Resturant.PNG";
import Project from "../../Assets/Projects/Project.png";
import Face from "../../Assets/Projects/Face.png";
import { FaCheckDouble } from "react-icons/fa";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Amazo}
              isBlog={false}
              title="Amazon_clone"
              description="Amazon Clone Using ReactJS"
              ghLink="https://github.com/sathwick9/Amazon-clone"
              demoLink="https://clone-dd52b.web.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Resturant}
              isBlog={false}
              title="Resturant site"
              description="Resturant site using HTML,JS,CSS"
              ghLink="https://github.com/sathwick9/Restaurant-site"
              demoLink="https://sathwick9.github.io/Restaurant-site/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Project}
              isBlog={false}
              title="Driver Drowsiness alert system"
              description="Driver Drowsiness Alert System with computer vision and stopping engine with raspberry pi"
              // ghLink="https://github.com/soumyajit4419/Editor.io"
              demoLink="https://drive.google.com/drive/folders/1Z7pQS9K-EU3Wgzth7bok9r6h2RjwSoN-?usp=sharing"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Face}
              isBlog={false}
              title="Vehicle And Pedestrian Detection"
              description="Detects vehicles and pedestrians"
              ghLink="https://github.com/sathwick9/opencv"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
